// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"703":"4a1af541","975":"cadb0668"}[chunkId] + ".chunk.css";
};